



















import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import Post from "@/components/timeline/_post.vue";
import Feed from "@/components/timeline/_feed.vue";

import { User } from "@/types";

@Component({
    computed: { ...mapGetters(["user"]) },
    components: {
        Post,
        Feed,
        // GameList,
    },
})
export default class PortfolioTimeline extends Vue {
    private userUid = this.$route.params.channel_id;

    private timeline: any = "";
    private user!: User;

    async created() {
        // this.timeline = await this.$api.getTimeline(
        //     this.userUid,
        //     undefined,
        //     parseInt(this.$route.params.porfolio_id)
        // );
    }

}
